import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=5763d1fe"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"
import style0 from "./Add.vue?vue&type=style&index=0&id=5763d1fe&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5763d1fe')) {
      api.createRecord('5763d1fe', component.options)
    } else {
      api.reload('5763d1fe', component.options)
    }
    module.hot.accept("./Add.vue?vue&type=template&id=5763d1fe", function () {
      api.rerender('5763d1fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Gravame/Add.vue"
export default component.exports